// packages/cross-config/index.ts
import { API_HOSTS } from "./host";
import { CROSS_API } from "./api";

const ENV = process.env.API_ENV || process.env.NEXT_PUBLIC_HOST_ENV;
const IS_DEV = __DEV__ || process.env.NODE_ENV !== "production";
const DOWNLOAD_PATH = "/download";

let config = API_HOSTS.prod;
switch (ENV) {
  case "dev":
    config = API_HOSTS.dev;
    break;
  case "beta":
    config = API_HOSTS.beta;
    break;
  case "pre":
    config = API_HOSTS.pre;
    break;
  case "prod":
    config = API_HOSTS.prod;
    break;
  default:
    break;
}
if (IS_DEV) {
  config = API_HOSTS.beta;
}

const {
  klineChartUrl,
  tvChartUrl,
  env,
  host,
  apiKeyBugsnag,
  fallbackUrl,
  packageName,
  domainUriPrefix,
  webDomain,
  operationServer,
  saasServer,
  googlePlayUrl,
  appStoreUrl,
  ossUrl,
  appDomain,
  staticHost,
  universalDownloadLink,
  aiChatUrl,
} = config;

const websocket: {
  host: string;
  appCode: string;
  stage: "TEST" | "RELEASE";
  registerPath: string;
  unregisterPath: string;
} = {
  host: config.websocket.host,
  stage: IS_DEV ? "TEST" : "RELEASE",
  appCode: "c022929d0e1f4b0d8eace9cb9934bf0d",
  registerPath: "/api/register",
  unregisterPath: "/api/unregister",
};

const languageUrl = `${ossUrl}/afront/adgm/language`;
const featureUrl = `${ossUrl}/afront/adgm/features`;
const errorConfigUrl = `${ossUrl}/afront/error`;
const pdfJsUrl = `${staticHost}/afront/adgm/pdf-viewer.html`; //在线pdf阅读器
const countryScoreUrl = `${ossUrl}/afront/adgm/country`;

const appBtcYtdUrl = `/yield/appBtcYtd`;
const assetsUrl = `/assets/mobile`;
const privacyPolicyUrl = `/policy`; // 弃用的隐私协议路由，统一使用用户协议landingPage页面，legalRegulatoryUrl
const riskDisclosureUrl = `/riskDisclosure`; // 弃用的风险披露路由，统一使用风险披露landingPage页面，legalRegulatoryUrl
const agreementUrl = `/agreement`; // 弃用的服务协议路由，统一使用用户协议landingPage页面，legalRegulatoryUrl
const appUploadUrl = `/profile/kyc/appUpload`;
const qrcodeUrl = `/qrcode`;
const legalRegulatoryUrl = `/legal-regulatory`;

//web端现在页面
const webDownload = `${webDomain + DOWNLOAD_PATH}?source=web`;
//apponly端下载页面
const appOnlyDownload = `${appDomain + DOWNLOAD_PATH}?source=web`;

export {
  websocket,
  host,
  klineChartUrl,
  tvChartUrl,
  env,
  apiKeyBugsnag,
  fallbackUrl,
  packageName,
  domainUriPrefix,
  webDomain,
  operationServer,
  saasServer,
  webDownload,
  appOnlyDownload,
  languageUrl,
  googlePlayUrl,
  appStoreUrl,
  ossUrl,
  appDomain,
  featureUrl,
  pdfJsUrl,
  errorConfigUrl,
  countryScoreUrl,
  staticHost,
  assetsUrl,
  privacyPolicyUrl,
  riskDisclosureUrl,
  agreementUrl,
  appBtcYtdUrl,
  appUploadUrl,
  API_HOSTS,
  CROSS_API,
  ENV,
  qrcodeUrl,
  legalRegulatoryUrl,
  universalDownloadLink,
  aiChatUrl,
};

// 导出 KYC 相关配置
export * from "./kyc";
